import React, { useContext, useEffect, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { CustomerWorkoutCreateFormData } from '../beans/customer.workout.create.form.data';
import {
    CustomerWorkoutCreateUpdate,
    resetCustomerWorkoutFormValue,
    resetWorkoutItem,
    setCustomerItem,
    setCustomerWorkoutFormValue,
    setWorkoutItem,
    setWorkoutSetItems,
} from '../state/customer.slice';
import { FormManager } from 'src/_shared/managers/form.manager';
import { NavigationManager } from 'src/_shared/managers/navigation.manager';
import { PopupManager } from 'src/_shared/managers/popup.manager';
import { QueueManager, QueueKeyType } from 'src/_shared/managers/queue.manager';
import { TranslatorManager } from 'src/_shared/managers/TranslatorManager';
import { WorkoutManager } from 'src/_shared/managers/workout.manager';
import { WorkoutSessionManager } from 'src/_shared/managers/workout.session.manager';
import { WorkoutSessionSetManager } from 'src/_shared/managers/workout.session.set.manager';
import { WorkoutSetManager } from 'src/_shared/managers/workout.set.manager';
import { RouteEnum } from 'src/_shared/routes';
import { store } from 'src/_shared/store/configure';
import { useStoreSelector } from 'src/_shared/store/hook';
import { FormHelperUtil } from 'src/_shared/utils/form.helper.util';
import {
    User,
    Workout,
    SessionCreateRequest,
    Session,
    ProgramSessionSetCreateRequest,
    ProgramSessionSetStatusEnum,
    SessionTitleUpdate,
    SetTransitByExerciseRequest,
} from 'src/api/entities';
import { PopupType } from 'src/features/_shared/components/Popup/popup.item';
import { TextField } from 'src/features/_shared/components/TextField';
import { setWorkoutDashboardItems, setWorkoutItems } from 'src/features/workout/store/workout.slice';
import { Button } from 'src/features/_shared/components/Button/button.component';
import { Calendar } from 'src/features/_shared/components/DatePicker/datepicker.component';
import { CustomerWorkoutSessionCreateSetFormData } from '../beans/customer.workout.session.create.form.data';
import 'react-datepicker/dist/react-datepicker.css';
import { WorkoutSessionCreateUpdate } from 'src/features/workout/store/workout.session.slice';
import { DashboardManager } from 'src/_shared/managers/dashboard.manager';
import { UserManager } from 'src/_shared/managers/user.manager';
import { WorkoutSessionSetTransitManager } from 'src/_shared/managers/workout.session.set.transit.manager';

export const CustomerWorkoutsArchivedView: React.FC = () => {
    const workoutManager = WorkoutManager.getInstance();
    const workoutSessionManager = WorkoutSessionManager.getInstance();
    const dashboardManager = DashboardManager.getInstance();
    const workoutSessionSetManager = WorkoutSessionSetManager.getInstance();
    const workoutSessionSetTransitManager = WorkoutSessionSetTransitManager.getInstance();
    const navigationManager = NavigationManager.getInstance();
    const customerManager = UserManager.getInstance();

    const queueManager = QueueManager.getInstance();
    const notificationManager = PopupManager.getInstance();
    const mavigationManager = NavigationManager.getInstance();
    const user: User = useStoreSelector(state => state.reducer.accessSlice.loggedUser);
    const workoutSetManager = WorkoutSetManager.getInstance();
    const customerItem: User = useStoreSelector(state => state.reducer.customerSlice.customer);
    const workouts: Workout[] = useStoreSelector(state => state.reducer.workoutSlice.workouts);
    const workoutsDashboard: Workout[] = useStoreSelector(state => state.reducer.workoutSlice.workoutsDashboard);
    const workoutCreateUpdate: CustomerWorkoutCreateUpdate = useStoreSelector(state => state.reducer.customerSlice.workoutCreateUpdate);
    const workoutItem: Workout = useStoreSelector(state => state.reducer.customerSlice.workout);
    const workoutSessionCreateUpdate: WorkoutSessionCreateUpdate = useStoreSelector(state => state.reducer.workoutSessionSlice.workoutSessionCreateUpdate);

    const getItems = async () => {
        const value = (await workoutManager.search(customerItem.id, true)).data!;
        console.log(value);
        store.dispatch(setWorkoutItems({ value }));
    };

    const getWorkoutHeadStatus = async () => {
        const value = await dashboardManager.getWorkoutHeadStatus({
            authorID: customerItem.id,
        });
        store.dispatch(setWorkoutDashboardItems({ value }));
    };

    useEffect(() => {
        getItems();
        getWorkoutHeadStatus();
    }, []);

    const handleCreateWorkout = async () => {
        const request: SessionCreateRequest = {
            data: {
                author: {
                    id: user.id!,
                    name: user.username,
                },
                assignee: {
                    id: customerItem.id!,
                    name: customerItem.data?.details?.firstName ?? '' + customerItem.data?.details?.lastName,
                },
                details: {
                    title: workoutCreateFormData.getValues('name'),
                },
            },
        };
        const response = await queueManager.queue(QueueKeyType.DEFAULT, workoutManager.create(request));
        store.dispatch(setWorkoutItem({ response }));

        const getItems = async () => {
            const value = (await workoutManager.search(customerItem.id)).data!;
            store.dispatch(setWorkoutItems({ value }));
            if (value.length > 0) {
                const sets = (await workoutSetManager.search(response.id!)).data;
                if (sets != undefined) {
                    store.dispatch(setWorkoutSetItems({ sets }));
                }
            }
        };
        await getItems();
        await getWorkoutHeadStatus();
    };

    const workoutCreateFormData = FormManager.getInstance().buildFormProxy<CustomerWorkoutCreateFormData>(
        CustomerWorkoutCreateFormData,
        handleCreateWorkout,
        {
            name: workoutCreateUpdate.name,
        },
        'onChange',
    );

    const [customerWorkoutSessionDateState, setCustomerWorkoutSessionDateState] = useState(new Date());

    const workoutSessionCreateFormData = FormManager.getInstance().buildFormProxy<CustomerWorkoutSessionCreateSetFormData>(
        CustomerWorkoutSessionCreateSetFormData,
        handleCreateWorkout,
        {
            sessionDate: workoutSessionCreateUpdate.sessionDate, // moment(customerWorkoutSessionDateState).format('YYYY-MM-DD'),
        },
        'onChange',
    );

    const handleOnBlur = (key: any, value: string) => {
        store.dispatch(setCustomerWorkoutFormValue({ key, value }));
    };

    const getWorkoutData = async (workoutID: number) => {
        const response = await workoutManager.getById(workoutID);
        store.dispatch(resetWorkoutItem());
        store.dispatch(setWorkoutItem({ response }));
        console.log(response);
    };
    const handleWorkoutDetail = async (workoutID: number) => {
        console.log(workoutItem);
        await getWorkoutData(workoutID);
        mavigationManager.navigateTo(RouteEnum.customersWorkoutsCreate);
    };
    const handleWorkoutRename = async (selectedWorkout: Session) => {
        console.log(selectedWorkout);
        workoutCreateFormData.setValue('name', selectedWorkout.title);
        notificationManager.show({
            type: PopupType.Info,
            title: 'Rinomina protocollo',
            icon: 'bi-clipboard2-pulse-fill',
            children: (
                <div className='d-flex mb-2'>
                    <div className='col'>
                        <TextField
                            type='text'
                            fullWidth
                            placeholder='Nome protocollo'
                            id='name'
                            {...workoutCreateFormData.register('name')}
                            error={workoutCreateFormData.errors.name}
                            errorMessage={workoutCreateFormData.errors.name && 'Campo obbligatorio'}
                            onBlur={(e: React.FocusEvent<HTMLInputElement, Element>) => {
                                workoutCreateFormData.setValue('name', e.target.value);
                                console.log(workoutCreateFormData.getValues('name'));
                            }}
                        />
                    </div>
                </div>
            ),
            ctas: {
                primary: {
                    cta: async () => {
                        const updateRequest: SessionTitleUpdate = {
                            title: workoutCreateFormData.getValues('name'),
                        };
                        await workoutManager.rename(selectedWorkout.id!, updateRequest);
                        await getItems();
                    },
                },
                close: {
                    cta: () => {
                        workoutCreateFormData.resetField('name');
                        // store.dispatch(resetCustomerWorkoutFormValue());
                    },
                },
            },
        });
    };

    const handleDeleteWorkout = async (workoutID: number) => {
        await workoutManager.delete(workoutID);
        await getItems();
    };

    const handleWorkoutArchive = async (workoutID: number) => {
        await workoutManager.archive(workoutID, false);
        await getItems();
        const notify = () => toast('Sessione estratta con successo!');
        notify();
    };

    const handleInspectSessions = async (workoutID: number) => {
        const response = await workoutManager.getById(workoutID);
        store.dispatch(setWorkoutItem({ response }));
        mavigationManager.navigateTo(RouteEnum.workoutSessions);
    };

    const handleCreateWorkoutSession = async (workout: Session) => {
        const response = await workoutSessionManager.create({
            status: 'DONE',
            data: {
                author: {
                    id: workout.assigneeID,
                    name: workout.assigneeName,
                },
                details: {
                    id: workout.id!,
                    name: workout.title,
                    date: workoutSessionCreateFormData.getValues('sessionDate'), // moment(customerWorkoutSessionDateState).format('YYYY-MM-DD'),
                },
            },
        });

        if (response != undefined) {
            const sets = (await workoutSetManager.search(workout.id!)).data;
            sets?.forEach(async currentSet => {
                const requestSet: ProgramSessionSetCreateRequest = {
                    authorId: workout.assigneeID,
                    authorName: workout.assigneeName,
                    sessionID: response.id!,
                    sessionName: response.sessionName,
                    setDate: response.sessionDate,
                    status: ProgramSessionSetStatusEnum.Done,
                    data: {
                        details: {
                            exercise: {
                                group: currentSet.exerciseGroup,
                                uuid: currentSet.exerciseUuid,
                                name: currentSet.exerciseName,
                            },
                            date: response.sessionDate,
                            rest: currentSet.rest,
                            rir: currentSet.rir,
                            rpe: currentSet.rpe,
                            reps: currentSet.reps,
                            weight: currentSet.weight,
                        },
                    },
                };
                await workoutSessionSetManager.create(response.id!, requestSet);
            });
        }

        const transitRequest: SetTransitByExerciseRequest = {
            sessionID: response.id,
            authorID: customerItem.id!,
        };
        workoutSessionSetTransitManager.transitBySession(transitRequest);
        await getWorkoutHeadStatus();
    };

    const handleInspectAnalysis = async (customerID: number) => {
        const value: User = await queueManager.queue(QueueKeyType.DEFAULT, customerManager.getUserById(customerID));
        store.dispatch(setCustomerItem({ value }));
        navigationManager.navigateTo(RouteEnum.customersAnalysis);
    };

    const handleStartCreate = () => {
        notificationManager.show({
            type: PopupType.Info,
            title: 'Crea protocollo',
            icon: 'bi-clipboard2-pulse-fill',
            maxWidth: 'xl',
            children: (
                <div className='d-flex mb-2'>
                    <div className='col'>
                        <TextField
                            type='text'
                            fullWidth
                            placeholder='Nome protocollo'
                            id='name'
                            {...workoutCreateFormData.register('name')}
                            error={workoutCreateFormData.errors.name}
                            errorMessage={workoutCreateFormData.errors.name && 'Campo obbligatorio'}
                            onBlur={(e: React.FocusEvent<HTMLInputElement, Element>) => handleOnBlur(e.target.name, e.target.value)}
                        />
                    </div>
                </div>
            ),
            ctas: {
                primary: {
                    cta: () => {
                        handleCreateWorkout(), mavigationManager.navigateTo(RouteEnum.customersWorkoutsCreate), store.dispatch(resetCustomerWorkoutFormValue());
                    },
                },
                close: {
                    cta: () => {
                        store.dispatch(resetCustomerWorkoutFormValue());
                    },
                },
            },
        });
    };
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [startSessionCreate, setStartSessionCreate] = useState(new Boolean(false));
    const [selectedWorkout, setSelectedWorkout] = useState({});

    moment.locale('it');

    return (
        <div className='App mt-5'>
            <Toaster />
            <div className='d-flex justify-content-between pb-2 px-2'>
                <h5>Customer {customerItem.username}</h5>
                <div className='d-flex justify-content-between pb-2 px-2 gap-3'>
                    <Button identifier='Nuovo workout' variant='primary' onClick={handleStartCreate} />
                    <Button identifier='Analisi' variant='primary' onClick={() => handleInspectAnalysis(customerItem.id!)} />
                </div>
            </div>
            <div className='d-flex flex-column'>
                {workouts.length > 0 && (
                    <div className='d-flex flex-column  mb-3 p-2'>
                        {workouts.map((workout: Session, index: number) => (
                            <>
                                <div className='d-flex flex-row justify-content-between align-items-center table-row mb-3'>
                                    <div className='d-flex flex-column align-items-start'>
                                        <h6>{workout.title}</h6>
                                        <p style={{ fontSize: '0.85rem', fontWeight: 'lighter', color: 'gray' }}>{`Creato il ${moment(workout.createdAt).format(
                                            'D MMMM YYYY',
                                        )}`}</p>
                                        {workoutsDashboard && workoutsDashboard.find(sess => sess.id == workout.id) && (
                                            <p style={{ fontSize: '0.85rem', fontWeight: 'lighter', color: 'gray' }}>{`${
                                                workoutsDashboard.find(sess => sess.id == workout.id)!.sessionsDone
                                            } sessioni completate`}</p>
                                        )}
                                        {workoutsDashboard && workoutsDashboard.find(sess => sess.id == workout.id) && (
                                            <p style={{ fontSize: '0.85rem', fontWeight: 'lighter', color: 'gray' }}>{`${
                                                workoutsDashboard.find(sess => sess.id == workout.id)!.groupCount
                                            } gruppi allenati`}</p>
                                        )}
                                        {workoutsDashboard && workoutsDashboard.find(sess => sess.id == workout.id) && (
                                            <p style={{ fontSize: '0.85rem', fontWeight: 'lighter', color: 'gray' }}>{`${
                                                workoutsDashboard.find(sess => sess.id == workout.id)!.exerciseCount
                                            } esercizi allenati`}</p>
                                        )}
                                    </div>
                                    <div className='d-flex gap-3'>
                                        <Button identifier='Dettagli' variant='primary' onClick={() => handleWorkoutDetail(workout.id!)} />
                                        <Button identifier='Rinomina' variant='primary' onClick={() => handleWorkoutRename(workout)} />
                                        <Button identifier='Estrai' variant='primary' onClick={() => handleWorkoutArchive(workout.id!)} />
                                        <Button identifier='Elimina' variant='secondary' onClick={() => handleDeleteWorkout(workout.id!)} />
                                        <Button identifier='Sedute' variant='secondary' onClick={() => handleInspectSessions(workout.id!)} />
                                        <Button
                                            identifier='Crea seduta'
                                            variant='secondary'
                                            onClick={() => {
                                                setStartSessionCreate(startSessionCreate == true ? false : true);
                                                setSelectedWorkout(workout);
                                            }}
                                        />
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                )}
            </div>
            {startSessionCreate == true && (
                <div className='row align-items-center justify-content-between py-4 px-4 my-3 mx-3' style={{ backgroundColor: '#f5f5f5', borderRadius: '10px' }}>
                    <div className='col-8 d-flex justify-content-start '>
                        <Calendar
                            identifier={''}
                            // value={workoutSessionCreateFormData.getValues('sessionDate')}
                            {...workoutSessionCreateFormData.register('sessionDate')}
                            selected={
                                workoutSessionCreateFormData.getValues('sessionDate') == ''
                                    ? moment(new Date()).toDate()
                                    : moment(workoutSessionCreateFormData.getValues('sessionDate')).toDate()
                            }
                            onChange={date => {
                                setSelectedDate(date as Date);
                                workoutSessionCreateFormData.setValue('sessionDate', date as Date);
                                console.log(workoutSessionCreateFormData.getValues('sessionDate'));
                            }}
                        />
                    </div>
                    <div className='col-4 d-flex justify-content-end gap-3'>
                        <Button
                            identifier='Crea seduta'
                            variant='primary'
                            onClick={() => {
                                handleCreateWorkoutSession(selectedWorkout);
                                setStartSessionCreate(false);
                            }}
                        />
                        <Button
                            identifier='Annulla'
                            variant='secondary'
                            onClick={() => {
                                setStartSessionCreate(false);
                                workoutCreateFormData.resetField('sessionDate');
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
